<template>
  <div class="home">
    <header-bar></header-bar>
    <section class="main">
      <div class="nav-left">
        <div class="nav-list">
          <div
            class="go-back-personal el-icon-arrow-left"
            @click="goUserCenter"
          >
            返回个人主页
          </div>
          <h3 class="on">帮助中心</h3>
        </div>
      </div>
      <div class="mainconten-right">
        <div class="form-title">常见问题</div>
        <div class="qes-box">
          <help-list
            v-for="(item, i) in questionListData"
            :key="i"
            :index="i"
            :dataList="item"
          ></help-list>
        </div>
        <div class="form-title mt50">我要反馈</div>
        <div class="fk-submit-box">
          <div class="set-discuss">
            <img v-if="userInfo" class="user-icon" :src="userInfo.icon||'/static/img/mr-usericon.png'" alt="" />
            <img v-else class="user-icon" src="/static/img/mr-usericon.png" alt="" />
            <div>
              <el-input placeholder="请输入标题" v-model="title" class="q-title"></el-input>
              <div class="textarea-box">
                <div class="pic-icon">
                  <el-popover
                    placement="top-start"
                    trigger="click"
                    popper-class="emoBox"
                  >
                    <div class="emotionList">
                      <a href="javascript:void(0);" class="emotionItem"
                        v-for="(item, index) in faceList" :key="index"
                        @click="getEmo(index)" >{{ item }}</a>
                    </div>
                    <el-button class="emotionSelect" slot="reference">
                      <img src="../../assets/images/icon/set-icon.png" alt="" />
                    </el-button>
                  </el-popover>
                </div>
                <div v-if="userToken" class="textarea">
                  <el-input
                    type="textarea"
                    placeholder="留下您的宝贵建议吧～"
                    v-model="textarea"
                    maxlength="200"
                    resize="none"
                    id="textarea"
                  >
                  </el-input>
                </div>
                <el-button v-if="userToken" class="discuss-btn" @click="discussBtn" >提交</el-button>
                <div v-else class="no-login">
                  请先<span @click="loginTo">登录</span>后反馈问题
                </div>
              </div>
            </div>

          </div>
        </div>
        <el-dialog
          title=""
          :visible.sync="dialogVisible"
          width="440px"
          :modal-append-to-body="false"
        >
          <div class="login-success">
            <img src="../../assets/images/login-success.png" alt="" />
            <div class="login-title">提交成功！感谢您的反馈～</div>
            <div class="login-sum">
              已收到您的宝贵问题，会尽快为您解决。
            </div>
            <div class="login-next">
              <el-button type="danger" @click="dialogVisible = false" round
                >知道了</el-button
              >
            </div>
          </div>
        </el-dialog>
      </div>
    </section>
  </div>
</template>
<script>
import store from "@/store";
import HeaderBar from "@/components/Header.vue";
import HelpList from "@/components/HelpList.vue";
import emoji from "emoji.json";
export default {
  name: "Home",
  components: {
    HeaderBar,
    HelpList,
  },
  data() {
    return {
      questionListData: [],
      userToken: store.state.UserToken
        ? store.state.UserToken
        : localStorage.getItem("UserToken"),
      userInfo: store.state.UserInfo
        ? store.state.UserInfo
        : JSON.parse(localStorage.getItem("UserInfo")),
      title: "",
      textarea: "",
      dialogVisible: false,
      faceList: [],
    };
  },
  mounted() {
    for(let i in emoji){
      this.faceList.push(emoji[i].char);
    }
  },
  methods: {
    //插入表情
    getEmo(index){
      var textArea = document.getElementById('textarea');
        function changeSelectedText(obj, str) {
          str = str + " ";
          if (window.getSelection) {
            // 非IE浏览器
            textArea.setRangeText(str);
            // 在未选中文本的情况下，重新设置光标位置
            textArea.selectionStart += str.length;
            textArea.focus()
          } else if (document.selection) {
            // IE浏览器
            obj.focus();
            var sel = document.selection.createRange();
            sel.text = str;
          }
        }
        changeSelectedText(textArea,this.faceList[index]);
        this.textarea = textArea.value;
        return;
    },
    goUserCenter() {
      if(this.userToken) {
        this.$router.push('/user/personal/' + this.userInfo.id)
      }else{
        this.$message.warning('请登录后查看');
      }
    },
    questionList() {
      this.$api.questionList({}).then((res) => {
        this.questionListData = res.data.data;
      });
    },
    loginTo() {
      this.$router.push("/login?url=" + window.location.pathname);
    },
    discussBtn() {
      if (!this.title) {
        this.$message.error("请输入标题");
        return false;
      }
      if (!this.textarea) {
        this.$message.error("请输入反馈意见");
        return false;
      }
      this.$api
        .questionAdd({
          title: this.title,
          content: this.textarea,
        })
        .then((res) => {
          this.$message.success(res.data.msg);
          this.dialogVisible = true;
          this.textarea = "";
          this.title = "";
        });
    },
  },
  created() {
    this.questionList();
  },
};
</script>
<style scoped lang="scss">
.main {
  width: 1000px;
  margin: 10px auto;
  margin-top: 70px;
  display: flex;
  justify-content: space-between;
  .nav-left {
    width: 250px;
    height: 903px;
    padding: 10px;
    background: #fff;
    .nav-list {
      h3 {
        padding-left: 18px;
        height: 48px;
        font-size: 20px;
        color: #121212;
        font-weight: 600;
        line-height: 48px;
        cursor: pointer;
        margin-top: 15px;
        &.on {
          color: #317DFF;
          background: #f5f5f5;
        }
      }
      .go-back-personal {
        width: 148px;
        height: 40px;
        line-height: 40px;
        background: #ffffff;
        border-radius: 4px;
        border: 1px solid #e5e5e5;
        font-size: 16px;
        font-weight: 400;
        color: #666666;
        cursor: pointer;
        padding-left: 15px;
      }
    }
    .nav-ul {
      li {
        height: 48px;
        line-height: 48px;
        font-size: 18px;
        padding-left: 30px;
        cursor: pointer;
        i {
          margin-right: 10px;
          font-size: 20px;
        }
        &.on {
          color: #317DFF;
          background: #f5f5f5;
        }
      }
    }
  }
  .mainconten-right {
    width: 740px;
    background: #fff;
    padding: 24px;
    .form-title {
      width: 100%;
      height: 26px;
      line-height: 26px;
      border-left: 4px solid #317DFF;
      padding-left: 10px;
      font-size: 18px;
      font-weight: 600;
      color: #121212;
    }
    .qes-box {
      width: 100%;
      padding: 12px;
    }
    .fk-submit-box {
      width: 100%;
      padding: 12px;
      .set-discuss {
        width: 100%;
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
        .user-icon {
          width: 32px;
          height: 32px;
          border-radius: 50%;
        }
        .q-title {
          /deep/ input {
            background: #f7f7f7;
          }
        }
        .textarea-box {
          margin-top: 10px;
          width: 620px;
          min-height: 123px;
          background: #f7f7f7;
          border-radius: 4px;
          border: 1px solid #eeeeee;
          .pic-icon {
            width: 100%;
            height: 28px;
            line-height: 28px;
            border-bottom: 1px solid #efefef;
            img {
              width: 12px;
              height: 12px;
              cursor: pointer;
            }
            button {
              border: none;
              padding: 6px 10px;
              background: none;
            }
          }
          .no-login {
            width: 100%;
            height: 94px;
            line-height: 94px;
            text-align: center;
            color: #121212;
            font-size: 15px;
            span {
              cursor: pointer;
              color: #317DFF;
            }
          }
          .textarea {
            width: 100%;
            /deep/ .el-textarea__inner {
              border: none !important;
              background: #f7f7f7 !important;
            }
          }
          .discuss-btn {
            width: 64px;
            height: 32px;
            text-align: center;
            line-height: 32px;
            color: #ffffff;
            background: #317DFF;
            border-radius: 4px;
            float: right;
            font-size: 15px;
            margin-right: 10px;
            padding: 0;
          }
        }
      }
    }
    /deep/ .el-dialog {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border-radius: 4px;
    .el-dialog__body {
      padding: 0;
      .login-success {
        width: 100%;
        padding: 10px 70px 50px;
        display: flex;
        align-items: center;
        flex-direction: column;
        img {
          width: 72px;
          height: 72px;
        }
        .login-title {
          font-size: 18px;
          font-weight: 600;
          color: #121212;
          margin-top: 15px;
        }
        .login-sum {
          font-size: 16px;
          font-weight: 400;
          color: #666666;
          text-align: center;
          line-height: 22px;
          margin-top: 20px;
        }
        .login-next {
          width: 100%;
          margin-top: 30px;
          display: flex;
          justify-content: space-around;
          .el-button {
            width: 128px;
            height: 40px;
            background: #317DFF;
            border-radius: 4px;
            font-size: 15px;
            color: #ffffff;
          }
          .el-button:nth-child(2) {
            background: #dddddd;
            border-radius: 4px;
            border: 1px solid #dddddd;
            color: #2f2f2f;
          }
        }
      }
    }
  }
  }
}
</style>
<style>
.emoBox {
  min-width: 100px;
  left: 265px;
  width: 400px;
  height: 200px;
  overflow: scroll;
}

.share-box {
  height: 24px;
  line-height: 24px;
  font-size: 14px;
  font-weight: 400;
  color: #333333;
  cursor: pointer;
  margin-bottom: 5px;
  display: flex;
  align-items: center;
}
.share-box img {
  width: 18px;
  height: 15px;
  margin-right: 10px;
}

.emotionList{
  display: flex;
  flex-wrap: wrap;
  padding:5px;
}
.emotionItem{
  width:10%;
  font-size:20px;
  text-align:center;
}
/*包含以下四种的链接*/
.emotionItem {
    text-decoration: none;
}
/*正常的未被访问过的链接*/
.emotionItem:link {
    text-decoration: none;
}
/*已经访问过的链接*/
.emotionItem:visited {
    text-decoration: none;
}
/*鼠标划过(停留)的链接*/
.emotionItem:hover {
    text-decoration: none;
}
/* 正在点击的链接*/
.emotionItem:active {
    text-decoration: none;
}

</style>



// WEBPACK FOOTER //
// src/views/user/personalHelp.vue